export default "__VITE_ASSET__B2uMJ8va__"